// frontend/packs/application.js

/* eslint-disable import/first, import/newline-after-import */

import 'init/polyfills';

import 'styleguide';
import 'init';

import 'layouts/page/page';
import 'components/global/site-header/site-header';
import 'components/global/main-nav/main-nav';
import 'components/global/site-footer/site-footer';

import 'components/sessions/login-form/login-form';
import 'components/sessions/registration-form/registration-form';
import 'components/sessions/reset-password-form/reset-password-form';
import 'components/sessions/update-password-form/update-password-form';

import 'components/util/ad-container/ad-container';
import 'components/util/logos/logos';

import { Application } from 'stimulus';
export const application = Application.start(); // eslint-disable-line import/prefer-default-export

import AdsController from '../controllers/ads-controller';
application.register('ads-main', AdsController);

import GoogleAnalyticsController from '../components/analytics/google/google-analytics-controller';
application.register('google-analytics', GoogleAnalyticsController);

import StickyAdController from '../components/util/ad-container/sticky-ad-controller';
application.register('ez-sticky-ad', StickyAdController);

import SiteHeaderController from '../components/global/site-header/site-header-controller';
application.register('site-header', SiteHeaderController);

import LanguageSwitcherController from '../components/util/language-switcher/language-switcher-controller';
application.register('language-switcher', LanguageSwitcherController);

import FlashMessageController from '../components/util/alerts/flash/flash-message-controller';
application.register('flash-message', FlashMessageController);

import EzModalController from '../layouts/modal/modal-controller';
application.register('ez-modal', EzModalController);

import LoginFormController from '../components/sessions/login-form/login-form-controller';
application.register('login-form', LoginFormController);

import SearchAnalyticsController from '../components/analytics/search/search-analytics-controller';
application.register('search-analytics', SearchAnalyticsController);

import SearchController from '../controllers/search-controller';
application.register('ez-search', SearchController);

import SearchFormController from '../components/search/search-form/search-form-controller';
application.register('search-form', SearchFormController);

import ShutterstockPopupController from '../controllers/shutterstock/popup-controller';
application.register('shutterstock-popup', ShutterstockPopupController);

import UserMenuController from '../components/global/main-nav/user-menu-controller';
application.register('user-menu', UserMenuController);

import RegistrationsAccountFormController from '../components/sessions/registration-form/account-form-controller';
application.register('registrations-account-form', RegistrationsAccountFormController);

import RegistrationsDetailsFormController from '../components/sessions/registration-form/details-form-controller';
application.register('registrations-details-form', RegistrationsDetailsFormController);

import ResetPasswordFormController from '../components/sessions/reset-password-form/reset-password-form-controller';
application.register('reset-password-form', ResetPasswordFormController);

import RecaptchaController from '../components/util/recaptcha/recaptcha-controller';
application.register('recaptcha', RecaptchaController);

import FacebookButtonController from '../components/util/facebook-button/facebook-button-controller';
application.register('facebook-button', FacebookButtonController);
